module.exports = __webpack_public_path__ + "181be464f66495af3a5968cf17bf36b7.png";